module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/104.45e0a922.png";